import React from 'react';

import {TypedValue} from 'notebook/tables/TableConstants';
import {getLibraryDefinitionFromTypedValue} from 'procedures/parameter-library/libraryParameterDefinitionTypedValueUtils';
import {LibraryParameterDefinitionIdName} from 'procedures/parameter-library/ParameterLibraryTypes';
import {InputChangeEvent} from 'util/Types';

import LibraryParameterDefinitionSearchInput from './LibraryParameterDefinitionSearchInput';

export interface LibraryParameterDefinitionSearchInputForTableCellProps {
  query: string;
  onQueryChange: (e: InputChangeEvent) => void;
  /** The name cell's current typed value; used to extract the selected library definition. */
  typedValue: TypedValue | null;
  onKeyDown?: (e: React.KeyboardEvent) => void;
  /** Receives id and name from the menu when the user selects, or null when cleared. */
  onSelect: (definition: LibraryParameterDefinitionIdName | null) => void;
}

/**
 * Wraps LibraryParameterDefinitionSearchInput for use in table cell editing (FormulaEditable).
 */
export default function LibraryParameterDefinitionSearchInputForTableCell({
  query,
  onQueryChange,
  typedValue,
  onKeyDown,
  onSelect,
}: LibraryParameterDefinitionSearchInputForTableCellProps): JSX.Element {
  const libDefTypedValue = getLibraryDefinitionFromTypedValue(typedValue);
  const selectedDefinition =
    libDefTypedValue != null ? {id: libDefTypedValue.id, name: libDefTypedValue.name} : null;
  const displayQuery =
    selectedDefinition != null && (query === '' || query === selectedDefinition.name) ? '' : query;

  return (
    <div
      onMouseDown={(e) => {
        e.stopPropagation();
      }}
    >
      <LibraryParameterDefinitionSearchInput
        query={displayQuery}
        onQueryChange={onQueryChange}
        onSelect={onSelect}
        selectedDefinition={selectedDefinition}
        onKeyDown={onKeyDown}
      />
    </div>
  );
}
